import { Switch } from '@ibsys/kit';
import { FC } from 'react';
import { FieldPath, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { cn } from '@/shared/lib';
import { ListInfoButton } from './ListInfoButton';
import { AttributeFormValues } from './validation';

type Props = {
  /** Путь признака в форме: у простого атрибута и у поля структуры он разный */
  name: FieldPath<AttributeFormValues>;
  disabled?: boolean;
  className?: string;
};

/**
 * Признак «Список» со значком справки по нему.
 * Значок стоит рядом с переключателем, а не в его подписи: подпись недоступного переключателя
 * приглушается вместе с ним, а справка нужна и тогда.
 */
export const ListField: FC<Props> = ({ name, disabled, className }) => {
  const { t } = useTranslation('attributes');
  const { control } = useFormContext<AttributeFormValues>();

  return (
    <div className={cn('flex items-center gap-1', className)}>
      {/* Switch кита по умолчанию на всю ширину: без w-auto значок уезжает от подписи к краю строки */}
      <Switch control={control} name={name} label={t('isList')} disabled={disabled} className="w-auto" />
      <ListInfoButton />
    </div>
  );
};
